import packageJson from '../../package.json';

export function VersionDisplay() {
	return (
		<div
			className='fixed top-[2px] right-[16px] text-[7px] px-1 py-0 rounded text-opacity-40 z-[99999999]'
			style={{ color: 'hsl(var(--muted-foreground))' }}>
			FAZ Ekonavi v{packageJson.version}
		</div>
	);
}
